module.exports = __webpack_public_path__ + "static/media/law.be6fd695.jpg";